<div id="layout" class="theme-cyan">
  <app-project-leftmenu></app-project-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body: -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container-fluid">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="avatar sm">
                  <a [routerLink]="['/app-project-invoice']" href="javascript:void(0)" title="" class="link"><i
                      class="zmdi zmdi-arrow-left zmdi-hc-lg"></i></a>
                </div>
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Invoices Details</h5>
                  </div>
                  <small class="text-truncate text-muted">Last Update your profile: 29 Aug 2020</small>
                </div>
              </div>
            </div>

            <!-- page action  -->
            <div class="col-7 col-xl-8 text-end">
              <ul class="nav justify-content-end d-inline-flex">
                <li class="nav-item list-inline-item d-none d-md-block me-2">
                  <a href="javascript:void(0)" class="nav-link text-muted px-3" (click)="isCollapsed = !isCollapsed"
                    [attr.aria-expanded]="!isCollapsed" aria-controls="collapseBasic" title="Search this chat">
                    <i class="zmdi zmdi-search zmdi-hc-lg"></i>
                  </a>
                </li>
                <li class="nav-item list-inline-item d-none d-md-block me-2">
                  <a class="nav-link text-muted" [routerLink]="['/app-project-invoice-create']"
                    href="javascript:void(0)">Add invoice</a>
                </li>
                <li class="nav-item list-inline-item d-none d-md-block me-2">
                  <button class="btn btn-sm btn-secondary" type="button">Export Report</button>
                </li>
                <li class="nav-item list-inline-item d-none d-md-block me-2">
                  <button class="btn btn-sm btn-primary" type="button">Print</button>
                </li>

                <!-- Mobile nav -->
                <li class="nav-item list-inline-item d-block d-sm-none px-3">
                  <div class="dropdown">
                    <a class="nav-link text-muted px-0" href="javascript:void(0)" data-bs-toggle="dropdown"
                      aria-haspopup="true" aria-expanded="false">
                      <i class="zmdi zmdi-more-vert zmdi-hc-lg"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                      <a class="dropdown-item" href="app-project-invoice-create.html">Add invoice</a>
                      <a class="dropdown-item" href="javascript:void(0)">Generate Report</a>
                      <a class="dropdown-item" href="javascript:void(0)">Export Report</a>
                    </div>
                  </div>
                </li>
                <!-- Mobile nav -->
              </ul>
            </div>

          </div>

        </div>
      </div>

      <!-- Body: Search -->
      <div class="collapse" id="collapseBasic" [collapse]="isCollapsed" [isAnimated]="true">
        <div class="container-fluid py-2">

          <div class="row">
            <div class="input-group">
              <input type="text" class="form-control" placeholder="Search...">
              <div class="input-group-append">
                <span class="input-group-text text-muted"><small>0 / 0</small></span>
              </div>
              <div class="input-group-append dropdown" dropdown placement="bottom right">
                <button type="button" class="btn btn-secondary">Search</button>


                <button id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic"
                  class="btn btn-secondary dropdown-toggle dropdown-toggle-split ml-1">
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <div id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                  aria-labelledby="button-basic">
                  <a href="javascript:void(0);" class="dropdown-item">Action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Another action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Something else here</a>
                  <div role="separator" class="dropdown-divider"></div>
                  <a class="dropdown-item" href="javascript:void(0)">Separated link</a>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container-fluid">

          <div class="row">
            <div class="col-12">
              <div class="card mb-3 invoice">
                <!-- begin invoice-company -->
                <div class="card-header">
                  <h6 class="card-title mb-0 fw-bold">Company Name, Inc</h6>
                </div>
                <!-- end invoice-company -->

                <!-- begin invoice-header -->
                <div class="card-body d-flex">
                  <div class="flex-fill invoice-from">
                    <small>from</small>
                    <address class="mt-2 mb-2">
                      <h6>Twitter, Inc.</h6>
                      Street Address<br>
                      City, Zip Code<br>
                      Phone: (123) 456-7890<br>
                      Fax: (123) 456-7890
                    </address>
                  </div>
                  <div class="flex-fill invoice-to">
                    <small>to</small>
                    <address class="mt-2 mb-2">
                      <h6>Company Name</h6>
                      Street Address<br>
                      City, Zip Code<br>
                      Phone: (123) 456-7890<br>
                      Fax: (123) 456-7890
                    </address>
                  </div>
                  <div class="flex-fill invoice-date">
                    <h6>Invoice / July period</h6>
                    <div class="date text-inverse mt-2">August 3,2020</div>
                    <div class="invoice-detail">
                      javascript:void(0)0000123DSS<br>
                      Services Product
                    </div>
                  </div>
                </div>
                <!-- end invoice-header -->

                <!-- begin invoice-content -->
                <div class="invoice-content">
                  <div class="table-responsive">
                    <table class="table table-hover">
                      <thead>
                        <tr>
                          <th>TASK DESCRIPTION</th>
                          <th class="text-center" width="10%">RATE</th>
                          <th class="text-center" width="10%">HOURS</th>
                          <th class="text-end" width="20%">LINE TOTAL</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <p class="mb-0">Website design &amp; development</p>
                            <small>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed id sagittis
                              arcu.</small>
                          </td>
                          <td class="text-center">$50.00</td>
                          <td class="text-center">50</td>
                          <td class="text-end">$2,500.00</td>
                        </tr>
                        <tr>
                          <td>
                            <p class="mb-0">Branding</p>
                            <small>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed id sagittis
                              arcu.</small>
                          </td>
                          <td class="text-center">$50.00</td>
                          <td class="text-center">40</td>
                          <td class="text-end">$2,000.00</td>
                        </tr>
                        <tr>
                          <td>
                            <p class="mb-0">Redesign Service</p>
                            <small>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed id sagittis
                              arcu.</small>
                          </td>
                          <td class="text-center">$50.00</td>
                          <td class="text-center">50</td>
                          <td class="text-end">$2,500.00</td>
                        </tr>
                        <tr>
                          <td colspan="3">
                            <div class="sub-price">
                              <small>SUBTOTAL</small>
                              <span class="fw-bold text-danger">$4,500.00</span>
                            </div>
                            <div class="sub-price">
                              <small>PAYPAL FEE (5.4%)</small>
                              <span class="fw-bold text-info">$108.00</span>
                            </div>
                          </td>
                          <td class="text-end">
                            <span class="h3 text-success">$4508.00</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- end invoice-content -->

                <!-- begin invoice-note -->
                <div class="card-footer">
                  * Make all cheques payable to [Your Company Name]<br>
                  * Payment is due within 30 days<br>
                  * If you have any questions concerning this invoice, contact [Name, Phone Number, Email]
                </div>
                <!-- end invoice-note -->
              </div>
            </div>
          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
